<template>
  <div>
    <div class="containerBackgroundTable bg-primary">
      <taskExportHeader></taskExportHeader>
    </div>
    <div>
      <taskTable class="alignTablaSobreFondo ml-5 mr-5 mt-6" />
    </div>
  </div>
</template>

<script>
import taskTable from "../../components/task/taskTable";
import taskExportHeader from "@/components/task-export/taskExportHeader";
const timeOut = 5000;
export default {
  data: () => ({
    search: "",
    refreshTask: null,
  }),
  components: {
    taskTable,
    taskExportHeader,
  },
  methods: {},
  mounted() {
    this.refreshTask = setInterval(() => {
      this.$store.dispatch("task/getAllTask");
    }, timeOut);
  },
  beforeDestroy() {
    clearInterval(this.refreshTask);
  },
};
</script>
<style src="@/styles/templateTable.css"></style>
